import { useCustomQueryWithParams } from 'shared/hooks/useCustomQueryWithParams'
import { useParams } from 'react-router-dom'
import { STREAMER_CONFIG } from '@/pages/Donation/api/streamer/constants'
import { streamerApi } from '@/pages/Donation/api/streamer'

export const useStreamerConfig = () => {
  const { username } = useParams()

  const {
    data: streamerConfigResponse,
    isLoading,
    isError,
  } = useCustomQueryWithParams(
    [STREAMER_CONFIG, username],
    async () => {
      if (!username) {
        return null
      }

      return await streamerApi.getStreamerConfig(username)
    },
    { enabled: !!username }
  )

  return {
    streamerConfig: streamerConfigResponse?.data ?? null,
    isLoading,
    streamerUsername: username,
    isError,
  }
}
